import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MultiSelectModule } from "primeng/multiselect";
import { ErrormessageModule } from '../../validation/errormessage/errormessage.module';

import { PCPTradePartnerMultiSelectComponent } from "./pcp-tradepartner-multi-select.component";

@NgModule({
    imports: [
        CommonModule,
        ErrormessageModule,
        FormsModule,
        MultiSelectModule,
        PCPTradePartnerMultiSelectComponent,
    ],
    exports: [PCPTradePartnerMultiSelectComponent]
})
export class PCPTradePartnerMultiSelectModule { }
